import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ChangeStockReservationWarehouseForm";
import GraphQLErrors from "../../components/GraphQLErrors";
import Loading from "../../components/Loading";
import {cancelChangeStockReservationWarehouse} from "../../actions/SubscriptionApiActions";
import {fromJS} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class ChangeStockReservationWarehouseFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.changeSubscriptionStockReservationWarehouse({deliveryId: this.props.deliveryId, warehouseId: values.get("warehouseId")})
      .then((response) => {
        if (response.data.changeSubscriptionStockReservationWarehouse.errors.length <= 0) {
          this.props.cancelChangeStockReservationWarehouse();
        } else {
          let errors = createValidationErrors(response.data.changeSubscriptionStockReservationWarehouse.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeStockReservationWarehouse();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />    
    return (
      <Form
        errors={this.state.errors}
        warehouses={fromJS(data.warehouses)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const START_DELIVERY = gql`
  mutation changeSubscriptionStockReservationWarehouse($data: SubscriptionStockReservationWarehouseInput!) {
    changeSubscriptionStockReservationWarehouse(input: $data) {
      errors { key message }
    }
  }
`;

const WAREHOUSES = gql`
  query warehouses {
    warehouses {
      id
    }
  }
`;

const withQueries = compose(
  graphql(WAREHOUSES),
  graphql(START_DELIVERY, {
    props: ({ mutate }) => ({
      changeSubscriptionStockReservationWarehouse: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelChangeStockReservationWarehouse})(withQueries(ChangeStockReservationWarehouseFormContainer));